import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchReconDetails } from '../../actions/reconciliationTypes'

const useFetchingReconDetails = (id) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchReconDetails(id))
  }, [dispatch, id])
}

export default useFetchingReconDetails
